﻿/*!
* Project Name: BuildTab Docs
* Project Description:A viewer for BIM CDE by BuildTab.
* @version 2.1.5- 2025-20-05
* @author Hai Minh
* @copyright 2025 BuildTab
* @license MIT
*
*/

async function loadManifest(manifestUrl) {
    try {

        const queryParams = new URLSearchParams(window.location.search);
        let viewurl = queryParams.get("viewurl");

        if (viewurl && viewurl.startsWith("/")) {
            viewurl = viewurl.substring(1); // loại bỏ dấu /
        }

        // ✅ Không có viewurl → khởi tạo viewer rỗng
        if (!viewurl) {
            console.warn("⚠️ Không có viewurl, khởi tạo viewer rỗng.");
            loadIFCVer2(null, null);
            return;
        }

        // 🔐 Tạo objectKey cho manifest
        const manifestKey = `${viewurl}/manifest.json`;
        const encodedKey = encodeURIComponent(manifestKey);

        // 🔗 Gọi trực tiếp API lấy presigned URL
        const presignedRes = await fetch(`https://dev-api-docs.buildtab.vn/api/v1/s3/presigned-url-for-download?key=${encodedKey}`, {
            method: "GET",
            headers: {
                Accept: "*/*"
            }
        });

        if (!presignedRes.ok) {
            throw new Error(`Không thể lấy presigned URL cho manifest: HTTP ${presignedRes.status}`);
        }

        const { presignedUrl: manifestUrl } = await presignedRes.json();

        if (!manifestUrl) {
            throw new Error("Không có presignedUrl trong phản hồi");
        }


        if (!manifestUrl) {
            throw new Error("Không có manifestUrl trong phản hồi server");
        }

        // 🧾 FE fetch nội dung manifest.json
        const manifestResponse = await fetch(manifestUrl);
        const manifest = await manifestResponse.json();

        if (!manifest || manifest.type !== "ifc") {
            throw new Error("Manifest không hợp lệ hoặc không phải model IFC.");
        }

        if (!Array.isArray(manifest.models)) {
            console.warn("📦 manifest.models không phải mảng thực, đang ép lại...");
            manifest.models = Array.from(manifest.models);
        }

        if (!Array.isArray(manifest.models) || manifest.models.length === 0) {
            throw new Error("Manifest không có models.");
        }

        for (let model of manifest.models) {
            model.id = model.id.replace(/\.ifc\.ifc$/, ".ifc");

            if (model.geometrySrc) {
                model.geometrySrc = await getPresignedUrlFromAPI(model.geometrySrc);
            }

            if (model.metadataSrc) {
                model.metadataSrc = await getPresignedUrlFromAPI(model.metadataSrc);
            }

            if (model.thumbnailSrc) {
                model.thumbnailSrc = await getPresignedUrlFromAPI(model.thumbnailSrc);
            }

            if (model.storeysSrc) {
                model.storeySrc = await getPresignedUrlFromAPI(model.storeysSrc);
            }
        }


        loadIFCVer2(viewurl, manifest);

    } catch (error) {
        console.error("❌ Lỗi khi tải manifest:", error);
    }
}

async function getPresignedUrlFromAPI(objectKey) {
    if (!objectKey) return null;

    try {
        const encodedKey = encodeURIComponent(objectKey);
        const response = await fetch(`https://dev-api-docs.buildtab.vn/api/v1/s3/presigned-url-for-download?key=${encodedKey}`, {
            method: "GET",
            headers: {
                Accept: "*/*"
            }
        });

        if (!response.ok) {
            console.warn(`⚠️ Không lấy được presigned URL cho ${objectKey}`);
            return null;
        }

        const data = await response.json();
        return data.presignedUrl;
    } catch (err) {
        console.error("❌ Lỗi gọi API presigned:", err);
        return null;
    }
}

function loadIFCVer2(viewurl, manifestData = null) {
    try {
        console.log("Manifest: ", manifestData);
        console.log(`🚀 Đang tải IFC Viewer với viewurl: ${viewurl}`);

        document.getElementById('loadmodePopup').style.visibility = 'hidden';
        document.getElementById('viewer-container').style.display = 'none';

        const oldIframe = document.getElementById('3dViewerIframe');
        if (oldIframe) {
            console.log("🔄 Đang xoá iframe cũ...");
            oldIframe.remove();
        }

        const iframe = document.createElement('iframe');
        iframe.id = '3dViewerIframe';
        iframe.src = `/ifcviewer/index.html?viewurl=${encodeURIComponent(viewurl || '')}`;

        // ✅ Truyền manifestData xuống iframe (nếu có)
        iframe.onload = () => {
            if (manifestData) {
                iframe.contentWindow.postMessage({
                    type: "initManifest",
                    viewurl,
                    manifest: manifestData
                }, "*");
            }
        };

        iframe.style.position = 'fixed';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '100vw';
        iframe.style.height = '100vh';
        iframe.style.zIndex = '1100';
        iframe.style.overflow = 'hidden';
        iframe.style.border = 'none';

        document.body.appendChild(iframe);
        window.parent.postMessage({ type: 'onViewerLoaded', modelType: '3D' }, '*');

        //console.log("✅ IFC Viewer đã được nhúng thành công:");
    } catch (error) {
        console.error("❌ Lỗi khi tạo iframe cho IFC Viewer:", error);
    }
}

document.addEventListener('DOMContentLoaded', handleAppInitialization);

async function handleAppInitialization() {
    const queryParams = new URLSearchParams(window.location.search);
    const viewUrlParam = queryParams.get('viewurl');

    const manifestUrl = `${viewUrlParam}/Compilation/Manifest.json`;
    //const accessToken = await getAccessToken();
    await loadManifest(manifestUrl);
}

window.addEventListener('message', function (event) {
    const { action, data, objectId, base64Image } = event.data || {};

    const messageHandlers = {
        // === 📥 Từ CDE → Viewer ===
        'onPinIssueModeActivate': () => sendMessageToViewer('onPinIssueModeActivate'),
        'onPinIssueModeInActivate': () => sendMessageToViewer('onPinIssueModeInActivate'),

        'onSidebySideMode': () => sendMessageToViewer('onSidebySideMode'),
        'offSidebySideMode': () => sendMessageToViewer('offSidebySideMode'),

        'renderIssuePins': () => {
            if (Array.isArray(data)) {
                sendMessageToViewer('onRenderIssuePins', { data });
            } else {
                console.warn('❌ Dữ liệu pins không hợp lệ:', data);
            }
        },

        'modelBrowser:open': () => sendMessageToViewer('modelBrowser:open'),
        'modelBrowser:close': () => sendMessageToViewer('modelBrowser:close'),
        'storeyBrowser:open': () => sendMessageToViewer('storeyBrowser:open'),
        'storeyBrowser:close': () => sendMessageToViewer('storeyBrowser:close'),
        'moveCameraToMinimapPoint': () => {
            if (!Array.isArray(data?.target) || !Array.isArray(data?.dir)) {
                console.warn('❌ moveCameraToMinimapPoint: dữ liệu không hợp lệ', data);
                return;
            }
            sendMessageToViewer('moveCameraToMinimapPoint', { data });
        },

        "flyToPinPosition": () => {
            if (!Array.isArray(data?.spritePosition) || data.spritePosition.length !== 3) {
                console.warn("⚠️ spritePosition không hợp lệ trong flyToPinPosition:", data);
                return;
            }

            console.log("📤 Portal forward flyToPinPosition:", data);

            sendMessageToViewer("flyToPinPosition", { data });
        },

        //'onLoadAdditionalModels': () => {
        //    if (Array.isArray(data)) {
        //        sendMessageToViewer('onLoadAdditionalModels', { additionalViewUrls: data });
        //    } else {
        //        console.warn('❌ Dữ liệu không hợp lệ cho onLoadAdditionalModels:', data);
        //    }
        //},
        'onLoadAdditionalModels': async (eventData) => {
            const data = eventData?.data;
            if (!Array.isArray(data)) {
                console.warn('❌ Dữ liệu không hợp lệ cho onLoadAdditionalModels:', data);
                return;
            }

            const manifests = [];

            for (const viewurl of data) {
                try {
                    console.log("📥 Nhận viewurl từ CDE:", viewurl);

                    let normalizedViewurl = viewurl;
                    //if (normalizedViewurl.endsWith('.ifc')) {
                    //    normalizedViewurl = normalizedViewurl.replace(/\.ifc$/, '');
                    //    console.log("🧼 Đã loại bỏ .ifc → normalizedViewurl:", normalizedViewurl);
                    //} //!!!!!!!!!!!!!!! Only use with Minio

                    const manifestKey = `${normalizedViewurl}/manifest.json`;
                    const encodedKey = encodeURIComponent(manifestKey);
                    console.log("🔑 manifestKey:", manifestKey);

                    const presignedRes = await fetch(`https://dev-api-docs.buildtab.vn/api/v1/s3/presigned-url-for-download?key=${encodedKey}`, {
                        method: "GET",
                        headers: { Accept: "*/*" }
                    });

                    if (!presignedRes.ok) {
                        console.warn(`⚠️ Không thể lấy presigned URL cho manifest: HTTP ${presignedRes.status}`);
                        continue;
                    }

                    const { presignedUrl: manifestUrl } = await presignedRes.json();
                    console.log("🔗 presigned manifest URL:", manifestUrl);

                    const manifestResponse = await fetch(manifestUrl);
                    const manifest = await manifestResponse.json();

                    if (!Array.isArray(manifest.models) || manifest.type !== "ifc") {
                        console.warn(`⚠️ Manifest từ ${viewurl} không hợp lệ.`);
                        continue;
                    }

                    for (let model of manifest.models) {
                        model.id = model.id.replace(/\.ifc\.ifc$/, ".ifc");

                        if (model.geometrySrc)
                            model.geometrySrc = await getPresignedUrlFromAPI(model.geometrySrc);

                        if (model.metadataSrc)
                            model.metadataSrc = await getPresignedUrlFromAPI(model.metadataSrc);

                        if (model.thumbnailSrc)
                            model.thumbnailSrc = await getPresignedUrlFromAPI(model.thumbnailSrc);

                        const storeyKey = `${viewurl}/Compilation/storeys.json`;
                        model.storeySrc = await getPresignedUrlFromAPI(storeyKey);
                    }


                    console.log("✅ Push manifest xuống viewer với viewurl:", normalizedViewurl);
                    manifests.push({ viewurl: normalizedViewurl, manifest });

                } catch (err) {
                    console.error(`❌ Lỗi xử lý manifest của ${viewurl}:`, err);
                }
            }

            if (manifests.length > 0) {
                console.log("📦 Gửi xuống viewer:", manifests);
                sendMessageToViewer('onLoadAdditionalModels', {
                    type: 'onLoadAdditionalModels',
                    manifests
                });
            } else {
                console.warn('⚠️ Không có manifest nào hợp lệ để gửi xuống viewer.');
            }
        },

        'onUnloadModels': () => {
            if (Array.isArray(data)) {
                sendMessageToViewer('onUnloadModels', { data });
            } else {
                console.warn('❌ Dữ liệu không hợp lệ cho onUnloadModels:', data);
            }
        },

        'onLocateObject': () => {
            if (typeof objectId === 'string' || Array.isArray(objectId)) {
                sendMessageToViewer('onLocateObject', { objectId });
                console.log("📍 Chuyển tiếp locate objectId(s):", objectId);
            } else {
                console.warn('❌ objectId không hợp lệ cho onLocateObject:', objectId);
            }
        },

        'onCaptureObjectImage': () => {
            if (objectId) {
                sendMessageToViewer('onCaptureObjectImage', { objectId });
            } else {
                console.warn('❌ Thiếu objectId cho onCaptureObjectImage');
            }
        },

        'onHoverObject': () => {
            if (typeof data === 'string') {
                sendMessageToViewer('onHoverObject', { data });
            } else {
                console.warn('❌ Dữ liệu không hợp lệ cho onHoverObject:', data);
            }
        },

        'onClearHighlights': () => {
            sendMessageToViewer('onClearHighlights');
        },

        'onHideObjects': () => {
            if (Array.isArray(data) || typeof data === 'string') {
                sendMessageToViewer('onHideObjects', { data });
            } else {
                console.warn('❌ Dữ liệu không hợp lệ cho onHideObjects:', data);
            }
        },

        'onShowObjects': () => {
            if (Array.isArray(data) || typeof data === 'string') {
                sendMessageToViewer('onShowObjects', { data });
            } else {
                console.warn('❌ Dữ liệu không hợp lệ cho onShowObjects:', data);
            }
        },

        'onSelectObjectsByIds': () => {
            if (Array.isArray(data) || typeof data === 'string') {
                sendMessageToViewer('onSelectObjectsByIds', { data });
            } else {
                console.warn('❌ Dữ liệu không hợp lệ cho onSelectObjectsByIds:', data);
            }
        },

        'onClearAllSelections': () => {
            sendMessageToViewer('onClearAllSelections', "*");

        },

        'onhighlightObjectsByIds': () => {
            if (Array.isArray(data) || typeof data === 'string') {
                sendMessageToViewer('onhighlightObjectsByIds', { data });
            } else {
                console.warn('❌ Dữ liệu không hợp lệ cho onhighlightObjectsByIds:', data);
            }
        },

        'onclearAllHighlights': () => {
            sendMessageToViewer('onclearAllHighlights', "*");

        },

        'onHideAllPins': () => {
            sendMessageToViewer('onHideAllPins');
        },

        'onHideRecentPin': () => {
            sendMessageToViewer('onHideRecentPin');
        },

        'onclearAllPins': () => {
            sendMessageToViewer('onclearAllPins');
        },

        'onActivateMultiSelectMode': () => {
            sendMessageToViewer('onActivateMultiSelectMode');
        },
        'onDeactivateMultiSelectMode': () => {
            sendMessageToViewer('onDeactivateMultiSelectMode');
        },

        "setToolbarBottomPx": () => {
            if (typeof data?.px !== "number") {
                console.warn("❌ px không hợp lệ trong setToolbarBottomPx:", data);
                return;
            }
            sendMessageToViewer("setToolbarBottomPx", { data });
        },

        "pinCalibrate": () => {
            sendMessageToViewer("onPinCalibrate");
        },

        "offPinCalibrate": () => {
            sendMessageToViewer("offPinCalibrate");
        },

        'onRenderPinCalibrates': () => {
            if (Array.isArray(data)) {
                sendMessageToViewer('onRenderPinCalibrates', { data });
            } else {
                console.warn('❌ Dữ liệu không hợp lệ cho onRenderPinCalibrates:', data);
            }
        },

        'onClearCalibratePins': () => {
            sendMessageToViewer('onClearCalibratePins');
        },

        "captureCurrentScreenshot": () => {
            sendMessageToViewer("captureCurrentScreenshot");
        },
        // === 📤 Viewer → Portal → CDE ===
        'onMultiSelectObjectAdded': () => forwardMessageToParent('onMultiSelectObjectAdded', data),
        'onMultiSelectObjectRemoved': () => forwardMessageToParent('onMultiSelectObjectRemoved', data),
        'pinCalibrateCreated': () => forwardMessageToParent('pinCalibrateCreated', data),
        'issueCreated': () => forwardMessageToParent('issueCreated', data),
        'onBimObjectClicked': () => forwardMessageToParent('onBimObjectClicked', data),
        'pinClicked': () => forwardMessageToParent('pinClicked', data),
        'onClickOnAPoint': () => forwardMessageToParent('onClickOnAPoint', data),
        'walkUpdate': () => forwardMessageToParent('walkUpdate', data),
        'screenshotCaptured': () => forwardMessageToParent('screenshotCaptured', data),
        "pinCreating": () => {
            forwardMessageToParent("pinCreating", null);
        },

        'objectImageCaptured': () => {
            forwardMessageToParent('objectImageCaptured', {
                objectId,
                base64Image
            });
        }
    };



    if (messageHandlers[action]) {
        messageHandlers[action](event.data);
    } else {
        if (event.source === window.parent) {
            sendMessageToViewer(action, data);
        } else {
            forwardMessageToParent(action, data);
        }
    }
});

/**
 * Gửi message xuống Viewer con (iframe)
 */
function sendMessageToViewer(action, data = {}) {
    const iframe = document.getElementById('3dViewerIframe');
    if (iframe?.contentWindow) {
        const message = { action, ...data };
        iframe.contentWindow.postMessage(message, "*");
    } else {
        console.warn("⚠️ Không tìm thấy iframe 3dViewerIframe");
    }
}

/**
 * Forward message từ Viewer lên CDE
 */
function forwardMessageToParent(action, data) {
    window.parent.postMessage({ action, data }, '*');
}


/**
 * Chuyển tiếp dữ liệu issue từ viewer lên CDE
 */
function forwardIssueToParent(issuePinData) {
    window.parent.postMessage({ action: 'issueCreated', data: issuePinData }, '*');
}

function getAccessToken() {
    return fetch('/api/get-access-token')
        .then(response => response.json())
        .then(data => data.accessToken)
        .catch(error => console.error('Error fetching access token:', error));
}
